import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tab,
  Tabs,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import HttpService from "../../../../hooks/Https-services";
import moment from "moment";
import MDEditor from "@uiw/react-md-editor";
import EditIcon from "@mui/icons-material/Edit";
import useConfig from "../../../../hooks/useConfig";
import { Delete } from "@mui/icons-material";
import PageRoutes, { APIRoutes } from "../../../../utils/constants";
import ActionButton, {
  ActionButtonGroup,
} from "../../../../Common/Component/ActionButton";
import SummaryEditor from "../../../../Common/Component/SummaryEditor";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

interface GameSummaryTableProps {
  listOfGameSummary: any[];
  pageData: {
    page: number;
    total_entries: number;
    limit: number;
  };
  GetGameSummary: () => void;
  page: number;
  rowsPerPage: number;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

const GameSummaryTable = ({
  listOfGameSummary,
  pageData,
  GetGameSummary,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
}: GameSummaryTableProps) => {
  const [openSummaryDialog, setOpenSummaryDialog] = useState(false);
  const [currentGame, setCurrentGame] = useState<any>({});
  const configData = useConfig();
  const [preGameSummary, setPreGameSummary] = useState("");
  const [postGameSummary, setPostGameSummary] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const handleStatusChange = async (id: string, status: boolean) => {
    try {
      await HttpService.post(
        `${APIRoutes.UpdateGameSummary.replace(":id", id)}`,
        {
          isActive: !status,
        }
      );
      GetGameSummary();
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      console.error("Error updating game summary status:", error);
    }
  };

  const handleOpenSummaryDialog = (row: any) => {
    setCurrentGame(row);
    setOpenSummaryDialog(true);
  };

  const handleDelete = async (id: string) => {
    try {
      await HttpService.post(
        `${APIRoutes.DeleteGameSummary.replace(":id", id)}`,
        {}
      );
      GetGameSummary();
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      console.error("Error deleting game summary:", error);
    }
  };

  const handleCloseSummaryDialog = () => {
    setOpenSummaryDialog(false);
    setPreGameSummary("");
    setPostGameSummary("");
  };
  useEffect(() => {
    if (currentGame) {
      setPreGameSummary(currentGame?.PreGameSummary);
      setPostGameSummary(currentGame?.PostGameSummary);
    }
  }, [currentGame]);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const generateSummary = async (type: "pre_match" | "post_match") => {
    setIsLoading(true);
    try {
      const response = await HttpService.post(
        `${APIRoutes.GenerateGameSummary.replace(
          ":gameId",
          currentGame?.GameID
        )}`,
        {
          channel: currentGame?.ChannelID,
          type: type,
        }
      );

      if (response?.data?.data) {
        if (type === "pre_match") {
          setPreGameSummary(response.data.data.content);
        } else {
          setPostGameSummary(response.data.data.content);
        }
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      console.error(`Error generating ${type}-game summary:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  const saveSummaries = async () => {
    try {
      await HttpService.post(
        `${APIRoutes.UpdateGameSummary.replace(":id", currentGame?.ID)}`,
        {
          preGameSummary,
          postGameSummary,
        }
      );
      handleCloseSummaryDialog();
      GetGameSummary();
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      console.error("Error saving game summaries:", error);
    }
  };

  return (
    <Box>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Game Name</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listOfGameSummary && listOfGameSummary.length > 0 ? (
                listOfGameSummary.map((row: any, index: number) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      <Link
                        to={PageRoutes.Watch.replace(":gameId", row.GameID)}
                        target="_blank"
                      >
                        {row.GameID}
                      </Link>
                    </TableCell>
                    <TableCell>
                      {row?.GameDetails?.away_team} AT{" "}
                      {row?.GameDetails?.home_team}
                    </TableCell>
                    <TableCell>
                      {row?.createdAt
                        ? moment(row?.createdAt).format("DD MMM YYYY hh:mm A")
                        : "Not Available"}
                    </TableCell>
                    <TableCell>
                      <ActionButtonGroup>
                        <ActionButton
                          width="200px"
                          onClick={() =>
                            handleStatusChange(row.ID, row.IsActive)
                          }
                          className={configData.buttonCommonClass}
                        >
                          {row.IsActive ? "Move to Pending" : "Make available"}
                        </ActionButton>

                        <ActionButton
                          width="50px"
                          onClick={() => handleOpenSummaryDialog(row)}
                          className={configData.buttonCommonClass}
                        >
                          <EditIcon />
                        </ActionButton>
                        <ActionButton
                          width="50px"
                          onClick={() => handleDelete(row.ID)}
                          className={configData.buttonCommonClass}
                        >
                          <Delete />
                        </ActionButton>
                      </ActionButtonGroup>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography variant="body1">No data found</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={pageData.total_entries}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* Summary Dialog */}
      <Dialog
        open={openSummaryDialog}
        onClose={handleCloseSummaryDialog}
        fullWidth
        maxWidth="xl"
      >
        <DialogTitle sx={{ color: "black" }}>Game Summaries </DialogTitle>
        <DialogContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs value={tabValue} onChange={handleTabChange}>
              <Tab label="Pre-Game Summary" />
              <Tab label="Post-Game Summary" />
            </Tabs>
          </Box>

          {/* Pre-Game Summary Tab */}
          <Box hidden={tabValue !== 0} sx={{ mt: 2, display: "flex" }}>
            <SummaryEditor
              summaryContent={preGameSummary}
              onSummaryChange={setPreGameSummary}
              onGenerateClick={() => generateSummary("pre_match")}
              isLoading={isLoading && tabValue === 0}
              generateButtonText="Generate with AI"
              loadingText="Generating..."
            />
          </Box>

          {/* Post-Game Summary Tab */}
          <Box hidden={tabValue !== 1} sx={{ mt: 2 }}>
            <SummaryEditor
              summaryContent={postGameSummary}
              onSummaryChange={setPostGameSummary}
              onGenerateClick={() => generateSummary("post_match")}
              isLoading={isLoading && tabValue === 1}
              generateButtonText="Generate with AI"
              loadingText="Generating..."
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSummaryDialog}>Cancel</Button>
          <Button onClick={saveSummaries} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default GameSummaryTable;
